// src/components/PartnershipForm.js
import React, { useState } from 'react';
import emailjs from 'emailjs-com';
import '../styles/CGU.css';
import { ToastContainer, toast } from 'react-toastify'

const PartnershipForm = () => {
  const [formData, setFormData] = useState({
    nom: '',
    entreprise: '',
    email: '',
    telephone: '',
    message: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const templateParams = {
      nom: formData.nom,
      entreprise: formData.entreprise,
      email: formData.email,
      telephone: formData.telephone,
      message: formData.message,
      timestamp: new Date().toISOString()
    };

    emailjs.send("service_lqqcwv6","template_8mq9b5v", templateParams, 'Zrkdw-wjCsct923Qy')
      .then((result) => {
         toast.success("Inscription à la liste d'attente réussie", {
                position: "top-right",
                autoClose: 3000, // Disparition après 3 secondes
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                theme: "colored",
            });
      }, (error) => {
          console.error('Erreur lors de l\'envoi de la demande :', error.text);

          alert("Erreur lors de l'envoi de la demande. Veuillez vérifier que tous les champs obligatoires sont remplis.");
      });

    setFormData({
      nom: '',
      entreprise: '',
      email: '',
      telephone: '',
      message: ''
    });
  };

  return (
    <form onSubmit={handleSubmit} className="partnership-form">
      <div className="form-group">
        <label htmlFor="nom">Nom</label>
        <input
          type="text"
          id="nom"
          name="nom"
          value={formData.nom}
          onChange={handleChange}
          placeholder="Votre nom"
          required
        />
      </div>
      <div className="form-group">
        <label htmlFor="entreprise">Nom de l'entreprise</label>
        <input
          type="text"
          id="entreprise"
          name="entreprise"
          value={formData.entreprise}
          onChange={handleChange}
          placeholder="Votre entreprise"
          required
        />
      </div>
      <div className="form-group">
        <label htmlFor="email">Adresse e-mail</label>
        <input
          type="email"
          id="email"
          name="email"
          value={formData.email}
          onChange={handleChange}
          placeholder="Votre e-mail"
          required
        />
      </div>
      <div className="form-group">
        <label htmlFor="telephone">Téléphone</label>
        <input
          type="tel"
          id="telephone"
          name="telephone"
          value={formData.telephone}
          onChange={handleChange}
          placeholder="Votre numéro de téléphone"
          required
        />
      </div>
      <div className="form-group">
        <label htmlFor="message">Votre proposition</label>
        <textarea
          id="message"
          name="message"
          value={formData.message}
          onChange={handleChange}
          rows="5"
          placeholder="Décrivez votre offre ou proposition..."
          required
        ></textarea>
      </div>
      <button type="submit" className="submit-button">Envoyer ma demande</button>
    </form>
  );
};

export default PartnershipForm;
